<template>
  <transition name="pop">
    <div
      v-if="needsAuth"
      @wheel.stop.prevent
      class="fixed inset-0 z-50 flex p-4"
    >
      <div
        class="rounded-2xl bg-deepWater opacity-95 max-w-max p-4 mx-auto my-auto"
      >
        <div class="sm:flex-nowrap flex flex-wrap items-center mb-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="max-h-24 sm:mb-0 w-40 px-4 mx-auto mb-2 fill-current"
          >
            <path
              d="M512 187.8l-.2-6.9-6.8-.6a38.2 38.2 0 01-34.4-31.5l-1.4-8.3-8 2.2a48.3 48.3 0 01-60.3-55.9l1.4-7.3-7.2-1.6a38.5 38.5 0 01-28.7-47l2.2-8.5-8.7-1a171.2 171.2 0 00-184.5 128.4h-4.5A171 171 0 000 320.7a171 171 0 00170.9 170.8c79.9 0 147.2-55.1 165.7-129.4h4.5A171 171 0 00512 187.9zM170.9 476.3c-85.9 0-155.7-69.8-155.7-155.6S85 165 171 165 326.5 235 326.5 320.7 256.7 476.3 171 476.3zM341 347h-1.4a171.1 171.1 0 00-148.9-196A156 156 0 01350.2 36 53.7 53.7 0 00385 90.6l-.3 5.6a63.5 63.5 0 0072.9 62.7 53.5 53.5 0 0039.2 35.4A155.8 155.8 0 01341 347z"
            />
            <path
              d="M320.5 77a23 23 0 100 46 23 23 0 000-46zm0 30.8a7.8 7.8 0 110-15.6 7.8 7.8 0 010 15.6zM229.9 108.3c-2.7 3.5-5.2 7.2-7.5 11l13 8c2-3.4 4.3-6.7 6.6-9.9l-12.1-9.1zM292 61c-20 7.9-38.4 20.4-53.1 36.4l11.2 10.3A128.4 128.4 0 01297.5 75L292 61zM457.4 236.2c-4 10-9.3 19.4-15.7 28l12.3 9c7.1-9.6 13-20.2 17.5-31.3l-14-5.7zM388.1 245.9a23 23 0 100 46 23 23 0 000-46zm0 30.7a7.8 7.8 0 110-15.5 7.8 7.8 0 010 15.5zM341.1 147.3a23 23 0 10.1 46 23 23 0 000-46zm0 30.8a7.8 7.8 0 110-15.6 7.8 7.8 0 010 15.6zM425.7 179.3a28.5 28.5 0 100 57 28.5 28.5 0 000-57zm0 41.7a13.3 13.3 0 110-26.5 13.3 13.3 0 010 26.5zM180.9 186.3a23 23 0 100 46 23 23 0 000-46zm0 30.7a7.8 7.8 0 110-15.5 7.8 7.8 0 010 15.5zM56.7 237c-2.6 3.6-5.2 7.3-7.5 11l13 8c2-3.4 4.3-6.7 6.7-9.8L56.7 237zM118.8 189.7c-20 8-38.4 20.5-53 36.5L77 236.4a128.3 128.3 0 0147.4-32.5l-5.6-14.2zM287.7 366.8c-4 9.9-9.3 19.3-15.7 28l12.2 9c7.2-9.7 13.1-20.2 17.6-31.3l-14-5.7zM63.4 380L50 387.4a143 143 0 0025 32.9l10.7-10.9A127.9 127.9 0 0163.4 380zM52.6 354l-14.7 4c1.5 5.6 3.4 11 5.6 16.3l14-5.8a127 127 0 01-5-14.5zM217.8 375.3a23 23 0 100 46 23 23 0 000-46zm0 30.7a7.8 7.8 0 110-15.5 7.8 7.8 0 010 15.5zM65.9 282.4a23 23 0 100 46 23 23 0 000-46zm0 30.7a7.8 7.8 0 110-15.5 7.8 7.8 0 010 15.5zM170.9 276.7a23 23 0 100 46 23 23 0 000-46zm0 30.7a7.8 7.8 0 110-15.5 7.8 7.8 0 010 15.5zM276.2 287.8a28.5 28.5 0 10.1 57 28.5 28.5 0 000-57zm0 41.7a13.3 13.3 0 110-26.5 13.3 13.3 0 010 26.5zM129.4 397.1a28.5 28.5 0 100 57 28.5 28.5 0 000-57zm0 41.7a13.3 13.3 0 110-26.5 13.3 13.3 0 010 26.5z"
            />
          </svg>
          <div class="sm:text-left w-full text-center">
            <p>
              Questo sito fa uso di cookie di terze parti
            </p>
          </div>
        </div>
        <div class=" sm:flex-nowrap flex flex-wrap items-center justify-center">
          <app-cta-button
            text="Accetto"
            class="w-40 lowercase"
            @click="consent"
          />
          <app-cta-button
            text="Non accetto"
            class="w-40 lowercase"
            @click="refuse"
          />
          <app-cta-button text="maggiori info" class="w-40 lowercase" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data: vm => ({
    needsAuth: !vm.$cookie.isCookieAvailable("consent")
  }),
  methods: {
    consent() {
      this.$cookie.setCookie("consent", true, {
        expire: "1y"
      });
      this.$gtm.enable(true);
      this.needsAuth = false;
    },
    refuse() {
      this.$cookie.setCookie("consent", false, {
        expire: "6h"
      });
      this.$gtm.enable(false);
      this.needsAuth = false;
    }
  },
  computed: {
    cookieConsent() {
      return this.$cookie.getCookie("consent") === "true";
    }
  },
  beforeMount() {
    this.$gtm.enable(this.cookieConsent);
  }
};
</script>
